import { LazySelectData } from './lazy-select.model'

export const getDefaultValueFromNativeSelect = (select: HTMLSelectElement): LazySelectData | LazySelectData[] => {
	const options = select.querySelectorAll<HTMLOptionElement>('option')
	const data = Array.from(options)
		.filter((option) => option.value !== '')
		.map((option) => ({ label: option.textContent || '', value: option.value }))

	if (select.multiple) {
		return data.filter((item) => {
			const opt = Array.from(options).find((option) => option.value === item.value)
			return opt?.selected === true
		})
	}

	const selected = data.find((item) => item.value === select.value)
	return selected || { label: '', value: '' }
}
